export const labels = {
    tamil: {
        formHeader: "வெளி நோயாளி பதிவு தகவல் படிவம்",
        patientName: "நோயாளியின் பெயர்",
        gender: "பாலினம்",
        age: "வயது",
        DOB: "பிறந்த தேதி",
        maritalStatus: "திருமண நிலை",
        unMarried: "திருமணமாகாதவர்",
        married: "திருமணமானவர்",
        fatherHusbandName: "தந்தை/கணவன் பெயர்",
        address1: "முகவரி 01",
        address2: "முகவரி 02",
        city: "நகரம்",
        state: "மாநிலம்",
        pincode: "பின்கோடு",
        occupation: "தொழில்",
        guardianName: "பாதுகாப்பாளர் பெயர்",
        mobileNo: "கைபேசி எண்",
        attenderEmergencyContactNo: "உடனிருப்பவர்/அவசர தொடர்பு எண்",
        emailId: "மின்னஞ்சல் முகவரி",
        referralSource: "நீங்கள் எங்களை எப்படித் தெரிந்துகொண்டீர்கள்?",
        terms: "நான் இந்த நேரத்தை முன்பதிவு செய்வதற்கான விதிமுறைகள் மற்றும் நிபந்தனைகளை ஏற்கின்றேன்.",
        description: 'மருத்துவமனையில் சிகிச்சையைப் பற்றிய விதிமுறைகள், ஒழுங்குகள் மற்றும் கட்டணங்கள் குறித்து எனக்கு தகவல் வழங்கப்பட்டுள்ளது.மருத்துவமனை மருத்தவர்கள் மற்றும் நர்ச்கள் என்னை(அல்லது என் பொறுப்பில் உள்ள நோயாளரை) பரிசோதிக்க எனது சம்மதத்தை வழங்குகிறேன்.இதில் தேவையான பரிசோதனைகள், நடைமுறைகள் மற்றும் சிகிச்சைகள் உட்பட அனைத்தும் சுகாதார சேவை வழங்குநர்கள் பரிந்துரைக்கும் விதத்தில் மேற்கொள்ளலாம்.என் நலனும் பாதுகாப்பும் கருதி மருத்துவ பணியாளர்கள் அனைத்து பொருத்தமான முன்னெச்சரிக்கைகளையும் எடுப்பார்கள் என்பதை நான் புரிந்துகொள்கிறேன், ஆனால் எந்தவொரு மருத்துவ நடைமுறையிலும் சில உட்பிறப்பு அபாயங்கள் இருக்கலாம் என்பதையும் நான் ஒப்புக்கொள்கிறேன்.',
        submit: "சமர்ப்பிக்கவும்",
        country: "நாடு",
    },
    hindi: {
        formHeader: "बाह्य रोगी पंजीकरण सूचना फॉर्म",
        patientName: "मरीज़ का नाम",
        gender: "लिंग",
        age: "उम्र",
        DOB: "जन्म तिथि",
        maritalStatus: "वैवाहिक स्थिति",
        unMarried: "अविवाहित",
        married: "विवाहित",
        fatherHusbandName: "पिता/पति का नाम",
        address1: "पता 01",
        address2: "पता 02",
        city: "शहर",
        state: "राज्य",
        pincode: "पिनकोड",
        occupation: "उपजीविका",
        guardianName: "अभिभावक का नाम",
        mobileNo: "मोबाइल नंबर",
        attenderEmergencyContactNo: "परिचारक/आपातकालीन संपर्क नंबर",
        emailId: "ईमेल आईडी",
        referralSource: "आपको हमारे बारे में कैसे पता चला?",
        terms: "मैं इस अपॉइंटमेंट को बुक करने के लिए नियम और शर्तों से सहमत हूँ।",
        description: 'मुझे अस्पताल में उपचार से संबंधित नियमों, विनियमों और शुल्कों की जानकारी दी गई है।मैं अपनी सहमति देता/देती हूँ कि मुझे (या उस रोगी को जिसकी जिम्मेदारी मेरी है) अस्पताल के डॉक्टरों और नर्सों द्वारा जांचा जाए।इसमें आवश्यक परीक्षण, प्रक्रियाएं और उपचार शामिल हैं, जैसा कि स्वास्थ्य सेवा प्रदाताओं द्वारा निर्धारित किया गया है।मैं समझता/समझती हूँ कि चिकित्सा कर्मचारी मेरी भलाई और सुरक्षा के लिए सभी उचित सावधानियां बरतेंगे, लेकिन मैं यह भी स्वीकार करता/करती हूँ कि किसी भी चिकित्सा प्रक्रिया या उपचार से कुछ अंतर्निहित जोखिम जुड़े हो सकते हैं।',
        submit: "जमा करें",
        country: "देश",
    },
    malayalam: {
        formHeader: "ഔട്ട് പേഷ്യന്റ് രജിസ്ട്രേഷൻ ഇൻഫർമേഷൻ ഫോം",
        patientName: "രോഗിയുടെ പേര്",
        gender: "ലിംഗഭേദം",
        age: "പ്രായം",
        DOB: "ജനനത്തീയതി",
        maritalStatus: "വൈവാഹിക നില",
        unMarried: "അവിവാഹിതൻ",
        married: "വിവാഹിതൻ",
        fatherHusbandName: "പിതാവ് / ഭർത്താവിൻ്റെ പേര്",
        address1: "വിലാസം 01",
        address2: "വിലാസം 02",
        city: "നഗരം",
        state: "സംസ്ഥാനം",
        pincode: "പിൻ കോഡ്",
        occupation: "തൊഴിൽ",
        guardianName: "ഗാർഡിയൻ നാമം",
        mobileNo: "മൊബൈൽ നമ്പർ",
        attenderEmergencyContactNo: "കൂട്ടിരിപ്പുകാരൻ/അടിയന്തര ബന്ധപ്പെടാനുള്ള നമ്പർ",
        emailId: "ഇമെയിൽ ഐഡി",
        referralSource: "റഫറൽ ഉറവിടം",
        terms: "ബുക്കിംഗ് നടത്തുന്നതിന് വേണ്ടി ആശുപത്രി നിബന്ധനകൾ ഞാൻ അംഗീകരിക്കുന്നു",
        description: 'ആശുപത്രിയിലെ ചികിത്സയുമായി ബന്ധപ്പെട്ട നിയമങ്ങൾ, ചട്ടങ്ങൾ, നിരക്കുകൾ എന്നിവയെക്കുറിച്ച് എന്നെ അറിയിച്ചിട്ടുണ്ട്. ആശുപത്രിയിലെ ഡോക്ടർമാരും നഴ്‌സുമാരും പരിശോധിക്കുന്നതിന് (അല്ലെങ്കിൽ ഞാൻ പരിശോധിക്കേണ്ട ഉത്തരവാദിത്തമുള്ള രോഗിയെ) ഞാൻ സമ്മതം നൽകുന്നു. ആരോഗ്യ സംരക്ഷണ ദാതാക്കൾ നിർദ്ദേശിക്കുന്ന ആവശ്യമായ പരിശോധനകൾ, നടപടിക്രമങ്ങൾ, ചികിത്സകൾ എന്നിവ ഇതിൽ ഉൾപ്പെടുന്നു. എന്റെ ക്ഷേമത്തിനും സുരക്ഷയ്ക്കും വേണ്ടി മെഡിക്കൽ സ്റ്റാഫ് എല്ലാ ന്യായമായ മുൻകരുതലുകളും എടുക്കുമെന്ന് ഞാൻ മനസ്സിലാക്കുന്നു, എന്നാൽ ഏതൊരു മെഡിക്കൽ നടപടിക്രമവുമായോ ചികിത്സയുമായോ അന്തർലീനമായ അപകടസാധ്യതകൾ ബന്ധപ്പെട്ടിരിക്കുന്നുവെന്ന് ഞാൻ സമ്മതിക്കുന്നു.',
        submit: "സമർപ്പിക്കുക",
        country: "രാജ്യം",
    },
    kannada: {
        formHeader: "ಹೊರರೋಗಿ ನೋಂದಣಿ ಮಾಹಿತಿ ಫಾರ್ಮ್",
        patientName: "ರೋಗಿಯ ಹೆಸರು",
        gender: "ಲಿಂಗ",
        age: "ವಯಸ್ಸು",
        DOB: "ಹುಟ್ಟಿದ ದಿನಾಂಕ",
        maritalStatus: "ವೈವಾಹಿಕ ಸ್ಥಿತಿ",
        unMarried: "ಅವಿವಾಹಿತ",
        married: "ವಿವಾಹಿತ",
        fatherHusbandName: "ತಂದೆ/ಗಂಡನ ಹೆಸರು",
        address1: "ವಿಳಾಸ 01",
        address2: "ವಿಳಾಸ 02",
        city: "ನಗರ",
        state: "ರಾಜ್ಯ",
        pincode: "ಪಿನ್ ಕೋಡ್",
        occupation: "ವೃತ್ತಿ",
        guardianName: "ಪೋಷಕರ ಹೆಸರು",
        mobileNo: "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
        attenderEmergencyContactNo: "ಸಹಾಯಕ/ತುರ್ತು ಸಂಪರ್ಕ ಸಂಖ್ಯೆ",
        emailId: "ಇಮೇಲ್ ವಿಳಾಸ",
        referralSource: "ನೀವು ನಮ್ಮ ಬಗ್ಗೆ ಹೇಗೆ ತಿಳಿದುಕೊಂಡಿರಿ?",
        terms: "ಈ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಲು ನಿಯಮಗಳು ಮತ್ತು ಷರತ್ತುಗಳನ್ನು ನಾನು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೇನೆ.",
        description: 'ಆಸ್ಪತ್ರೆಯಲ್ಲಿ ಚಿಕಿತ್ಸೆಗೆ ಸಂಬಂಧಿಸಿದ ನಿಯಮಗಳು, ನಿಬಂಧನೆಗಳು ಮತ್ತು ಶುಲ್ಕಗಳ ಕುರಿತು ನನಗೆ ಮಾಹಿತಿ ನೀಡಲಾಗಿದೆ. ಆಸ್ಪತ್ರೆಯ ವೈದ್ಯರು ಮತ್ತು ನರ್ಸ್‌ಗಳು ನನ್ನನ್ನು (ಅಥವಾ ನನ್ನ ಜವಾಬ್ದಾರಿಯಲ್ಲಿರುವ ರೋಗಿಯನ್ನು) ಪರೀಕ್ಷಿಸಲು ನನ್ನ ಒಪ್ಪಿಗೆಯನ್ನು ನೀಡುತ್ತೇನೆ. ಇದರಲ್ಲಿ ಅಗತ್ಯವಿರುವ ಪರೀಕ್ಷೆಗಳು, ಕಾರ್ಯವಿಧಾನಗಳು ಮತ್ತು ಚಿಕಿತ್ಸೆಗಳು ಸೇರಿದಂತೆ ಆರೋಗ್ಯ ಸೇವಾ ಪೂರೈಕೆದಾರರು ಶಿಫಾರಸು ಮಾಡಿದ ರೀತಿಯಲ್ಲಿ ಎಲ್ಲವನ್ನೂ ಕೈಗೊಳ್ಳಬಹುದು. ನನ್ನ ಹಿತ ಮತ್ತು ಸುರಕ್ಷತೆಯನ್ನು ಗಮನದಲ್ಲಿಟ್ಟುಕೊಂಡು ವೈದ್ಯಕೀಯ ಸಿಬ್ಬಂದಿ ಎಲ್ಲಾ ಸೂಕ್ತ ಮುನ್ನೆಚ್ಚರಿಕೆಗಳನ್ನು ತೆಗೆದುಕೊಳ್ಳುತ್ತಾರೆ ಎಂದು ನಾನು ಅರ್ಥಮಾಡಿಕೊಳ್ಳುತ್ತೇನೆ, ಆದರೆ ಯಾವುದೇ ವೈದ್ಯಕೀಯ ವಿಧಾನದಲ್ಲಿ ಕೆಲವು ಅಂತರ್ಗತ ಅಪಾಯಗಳಿರಬಹುದು ಎಂದು ನಾನು ಒಪ್ಪಿಕೊಳ್ಳುತ್ತೇನೆ.',
        submit: "ಸಲ್ಲಿಸು",
        country: "ದೇಶ",
    }
};